<template>
  <div class="form-field form-datetime" :rel="computedRelName" v-bind:class="wrapperClasses">
    <div class="form-label">
      <label>{{ label }}</label>
    </div>
    <div class="form-input">
      <!--
      <div>
        {{ localValue }}<br>
        {{ internalInput }} - {{ internalInputTime }}
      </div>-->
      <div class="form-input-wrapper">

        <label class="form-input-toggleable" v-if="toggleable">
          <input type="checkbox" v-model="disabled" @change="toggle"/>
        </label>

        <div class="date">
          <icon name="calendar"/>
          <input type="text" v-model="internalInput" maxlength="10" :disabled="isDisabled" placeholder="jj.mm.aaaaa"/>
        </div>
        <datepicker
            v-model="datepickerDefault"
            name="uniquename"
            format="yyyy-MM-dd"
            :clear-button="false"
            clear-button-icon="icon icon-icon_close"
            @selected="dateSelected"
            v-if="!isDisabled" style="width: 100px;">
        </datepicker>

        <div class="datetime" v-if="!hideTime" style="width: 120px;" :disabled="isDisabled">
          <icon name="clock"/>
          <vue-timepicker v-model="internalInputTime" :format="inputFormatTime" hide-clear-button></vue-timepicker>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Translator from "./Translator.vue";

export default {
  name: 'FormField',
  props: {
    name: {
      default: "",
      required: false
    },
    value: {
      required: false
    },
    label: {
      default: null
    },
    hint: {
      default: null
    },
    utcToLocale: {
      default: null
    },
    formatTime: {
      default: null
    },
    time: {
      default: null
    },
    hideTime: {
      default: false
    },
    disabled: {
      default: false
    },
    required: {
      default: false
    },
    toggleable: {
      default: false
    },
  },
  components: { Datepicker },
  data: function () {
    var DEFAULT_DATE = '00-00-0000';
    var DEFAULT_TIME = '00:00:00';

    return {
      uniqueId: Math.random().toString(36).substr(2, 9),
      datepickerDefault: null,
      internalInput: null,
      internalInputTime: null,
      sep: '-',
      inputFormat: 'DD-MM-YYYY',
      inputFormatTime: 'HH:mm:ss',
      timePlaceholder: DEFAULT_TIME,
      DEFAULT_DATE: DEFAULT_DATE,
      DEFAULT_TIME: DEFAULT_TIME,
      localValue: this.value,
    };
  },
  created: function () {
    this.localeDate = this.locale || 'UTC';
    this.modelUpdated(this.localValue);
  },
  computed: {
    wrapperClasses: function () {
      return { 'has-suffix': this.suffix, 'form-required': this.isRequired, 'form-readonly': this.isReadonly, 'has-lang': this.lang, 'form-disabled': this.isDisabled };
    },
    computedRelName: function () {
      return this.name ? this.name : this.uniqueId;
    },
    isReadonly: function () {
      return this.readOnly && (this.readOnly == 'true' || this.readOnly == true) ? true : false;
    },
    isDisabled: function () {
      return this.disabled && (this.disabled == 'true' || this.disabled == true) ? true : false;
    },
    isRequired: function () {
      return this.required && (this.required == 'true' || this.required == true) ? true : false;
    }
  },
  methods: {
    toggle: function () {
      if(this.disabled){
        this.$emit('input', null);
      }else{
        this.setFinalDateTime();
      }
    },
    removeTime: function () {
      this.internalInputTime = this.DEFAULT_TIME;
      this.setFinalDateTime();
    },
    removeDate: function () {
      this.internalInput = this.DEFAULT_DATE;
      this.internalInputTime = this.DEFAULT_TIME;
      this.setFinalDateTime();
    },
    dateSelected: function (dateString) {
      if (dateString) {
        this.internalInput = moment(dateString).format(this.inputFormat);
        this.setFinalDateTime();
      }
    },
    modelUpdated: function (dateString) {
      if (dateString) {
        var timezone = this.$store.state.scope.timezone;
        var date = moment.tz(dateString, timezone); // Utilise le fuseau horaire global

        this.internalInput = date.format(this.inputFormat);
        this.internalInputTime = date.format(this.inputFormatTime);
      }
    },
    setFinalDateTime: function () {

      if( this.internalInputTime === undefined || this.internalInputTime === null ){
        this.internalInputTime = this.time || this.DEFAULT_TIME;
      }

      var time = this.internalInputTime;
      var date = new Date(this.localValue);
      var timezoneOffset = date.getTimezoneOffset() / 60;
      var offset = timezoneOffset > 0
          ? "-0" + Math.abs(timezoneOffset) + ":00"
          : "+0" + Math.abs(timezoneOffset) + ":00";

      if( this.hideTime ){
        time = this.time || this.DEFAULT_TIME;
      }

      var dateUtc = null;

      if( this.internalInput != this.DEFAULT_DATE )
      {
        var dateFormatted = moment(this.internalInput, this.inputFormat).format('YYYY-MM-DD');
        var dateLocale = dateFormatted + "T" + time + offset;
        dateUtc = moment.utc(dateLocale).toISOString();
      }

      this.localValue = dateUtc; // Met uniquement à jour localValue
      this.$emit('input', dateUtc); // Notifie le parent
    }
  },
  watch: {
    value: function (newVal) {
      // Mettez à jour localValue lorsque la prop change depuis le parent
      this.localValue = newVal;
      this.modelUpdated(newVal);
    },
    internalInputTime: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setFinalDateTime();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/form/Datetime.vue